/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddNotificationTokenMutationVariables = {|
  notificationId?: ?string
|};
export type AddNotificationTokenMutationResponse = {|
  +updateProfile: ?{|
    +message: ?string
  |}
|};
export type AddNotificationTokenMutation = {|
  variables: AddNotificationTokenMutationVariables,
  response: AddNotificationTokenMutationResponse,
|};
*/


/*
mutation AddNotificationTokenMutation(
  $notificationId: String
) {
  updateProfile(notificationId: $notificationId) {
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "notificationId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "notificationId",
        "variableName": "notificationId"
      }
    ],
    "concreteType": "UpdateProfile",
    "kind": "LinkedField",
    "name": "updateProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddNotificationTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddNotificationTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4aefffe0d775b26305958b50f9e3c048",
    "id": null,
    "metadata": {},
    "name": "AddNotificationTokenMutation",
    "operationKind": "mutation",
    "text": "mutation AddNotificationTokenMutation(\n  $notificationId: String\n) {\n  updateProfile(notificationId: $notificationId) {\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '789ba92eeb932387f268d0e2fd9434b7';

module.exports = node;
